import { History, Location } from "history";
import { match } from "react-router";
import { getToken } from "@my-dld/utils/User";
import { hideLoading, showLoading } from "./UIUtils";
import { getConsumerId } from "../configApp";

export interface RoutedViewProps<Params = any, LState = any> {
	history: History;
	location: Location<LState>;
	match: match<Params>;
}

export function getSiteRootUrl() {
	let rootUrl = "/";
	if ( window.siteRootUrl ) {
		rootUrl = window.siteRootUrl;
	}
	return rootUrl;
}

export function getSiteLocaleRootUrl() {
	let rootUrl = getSiteRootUrl();
	if ( window.AppInfo && window.AppInfo.I8N && window.AppInfo.I8N.locale ) {
		rootUrl = rootUrl + window.AppInfo.I8N.locale + "/";
	}
	return rootUrl;
}

export function sanitizeTabuMobileDocumentUrlNext( url: string, headers?: { [key: string]: string } ) {
	if ( url ) {
		if ( url.startsWith( "http://" ) ) {
			url = "https" + url.substr( url.indexOf( ":" ) );
		}
	}
	downloadFile(url, headers);
}

function isPDF(url: string ) {
	return /\.(pdf)$/.test(url);
}
export function downloadFile( pdfURL?: string, headers?: { [key: string]: string } ) {
	if ( pdfURL ) {
		showLoading();
		var params = {
			...headers,
			"token": getToken() ?? "", "consumer-id": getConsumerId(pdfURL) ?? ""
		};
		fetch( pdfURL, { headers: params } ).then( r => r.blob() )
		.then( blob => {
			let newBlob = isPDF(pdfURL) ? new Blob( [ blob ], { type: "application/pdf" } ) : blob;
			let url = window.URL.createObjectURL( newBlob );
			let a = document.createElement( "a" );
			a.href = url;
			a.download = pdfURL;
			a.click();
			hideLoading();
		} ).catch( e => hideLoading() );
	}

}
